import { useAppsStore } from "@/pinia/appsStore";
import { computed } from "vue";
import { ENGAGEMENT_SUBCATEGORIES_BY_CATEGORY } from "@/utils/constants/EngagementCategoryConstants";

export const useEngagementSubcategories = () => {
  const appsStore = useAppsStore();

  // Server payload shape: hash { [category]: [{ value, label, description }] }
  // or flat array [{ category, value, ... }]
  const payload = computed(() => appsStore.app?.engagement_subcategories || {});

  const listForCategory = category => {
    const fromPayload = Array.isArray(payload.value)
      ? payload.value.filter(s => s?.category === category)
      : payload.value[category];
    return fromPayload?.length
      ? fromPayload.filter(Boolean)
      : ENGAGEMENT_SUBCATEGORIES_BY_CATEGORY[category] || [];
  };

  const radioOptionsForCategory = category => [
    { value: "none", label: "None" },
    ...listForCategory(category).map(s => {
      const label = s?.label ?? s?.value ?? "";
      return {
        value: s.value,
        label: label.endsWith("Churn") ? label : `${label} Churn`,
        description: s.description,
      };
    }),
  ];

  const hasSubcategories = category => listForCategory(category).length > 0;

  const isSubcategoryAllowedFor = (category, subcategory) =>
    subcategory == null || listForCategory(category).some(s => s?.value === subcategory);

  const subcategoryDescription = value =>
    Object.values(payload.value)
      .flat()
      .find(s => s?.value === value)?.description ??
    Object.values(ENGAGEMENT_SUBCATEGORIES_BY_CATEGORY)
      .flat()
      .find(s => s?.value === value)?.description;

  return {
    radioOptionsForCategory,
    hasSubcategories,
    isSubcategoryAllowedFor,
    subcategoryDescription,
  };
};
